import { Loading } from 'react-admin';
import Loadable from 'react-loadable';
import { Navigate } from 'react-router-dom';

const statisticShow = Loadable({ loader: () => import('./statisticShow'), loading: Loading });
const StatisticsList = () => <Navigate to="/statistics/1/show" replace />;

export default { 
  list: StatisticsList,
  show: statisticShow
};